import {useState} from 'react'
import SalesOrderForm from './SalesOrderForm';
import SalesOrderList from './SalesOrderList';

const SalesOrder = () => {
  const [fromIsShown, setFromIsShown] = useState(false);
  const [upData, setUpData] = useState(false);

return (
  <>
    {fromIsShown ? (
        <SalesOrderForm addForm={setFromIsShown} update={upData} />
      ) : (
        <SalesOrderList addForm={setFromIsShown} update={setUpData} />
      )}

  </>
)
}

export default SalesOrder